import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CollectingStep1 } from '../components/Collecting/CollectingStep1/CollectingStep1'
import { CollectingStep2 } from '../components/Collecting/CollectingStep2/CollectingStep2'
import { CollectingStep3 } from '../components/Collecting/CollectingStep3/CollectingStep3'
import { TransactionFlowPage } from '../components/Transaction/TransactionFlowPage'
import { useCollectingFormContext } from '../context/collectingContext'
import { withErrorBoundary } from '../components/hoc/withErrorBoundary'
import { mapKlantTransactieToFormValues } from '../utils/collectingMapper'

const Collecting = () => {
  return (
    <TransactionFlowPage
      search={Route.useSearch()}
      i18nPrefix='collecting'
      editTitleKey='collecting.editCollecting'
      createTitleKey='collecting.newCollecting'
      useFormContext={useCollectingFormContext}
      mapTransactionToFormValues={mapKlantTransactieToFormValues}
      Step1Component={CollectingStep1}
      Step2Component={CollectingStep2}
      Step3Component={CollectingStep3}
    />
  )
}

export const Route = createFileRoute('/collecting')({
  validateSearch: z.object({
    mode: z.enum(['create', 'edit']).catch('create'),
    transactionId: z.string().optional(),
  }),
  component: withErrorBoundary(Collecting),
})
